import { StyleSheet } from 'aphrodite';

export const styles = StyleSheet.create({
  container: {
    textAlign: 'left',
    whiteSpace: 'pre-line',
    position: 'relative',
    overflowY: 'auto',
    overflowX: 'hidden',
    padding: 'calc(var(--sp-lg)*1.5) calc(var(--sp-lg)*1.6) calc(var(--sp-lg)*8)',
    backgroundColor: "#fff",
  },

  tabContainer: {
    display: "flex",
    marginTop: "var(--sp-lg)",
    alignItems: "center",
    height: "100%",
    width: "100%",
  },

  tabIndicatorStyle: {
    background: "#F8B218",
    textTransform: "capitalize",
  },

  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
  },

  subscriptionContainer: {
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    paddingTop: "var(--sp-lg)"
  },

  cancelModalContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: 'var(--sp-lg) 0px',
  },

  billingTableTd: {
    padding: "var(--sp-lg) var(--sp-md2)",
  },

  billingTableTr:{
    borderBottom: "1px solid #ddd",
  },

  billContainer: { 
    display: "flex", 
    flexDirection: "column",
    alignItems: "center",
  },
  
  billLocationSpan: { 
    fontWeight: 600, 
    fontSize: "var(--fs-md2)", 
    color: "#000",
  },

  billStatus: {
    padding: "var(--sp-md) var(--sp-lg)",
    backgroundColor: "#C1FFDE",
    borderRadius: "calc(var(--sp-md2)*1.13207)",
    fontSize: "calc(var(--fs-xs)*1.13207)",
    fontWeight: 500,
    color: "#23A30E",
    marginLeft: "var(--sp-xs)",
    textTransform: "capitalize",
  },

  expirySpan :{
    fontWeight: 400, 
    fontSize: "var(--fs-sm2)",
  },

  expiryInfo: {
    padding: "var(--sp-xs) calc(var(--sp-xxs)*2)",
    backgroundColor: "#FC0101",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    borderRadius: "var(--sp-xs)",
    width: "fit-content",
    marginTop: "calc(var(--sp-md2)*1.41509)",
  },

  expirySpanSize:{
    fontSize: "var(--fs-sm2)", 
    marginRight: "var(--sp-xs)",
  },

  expirySpanWeight:{ 
    fontWeight: 700, 
    fontSize: "var(--fs-sm2)", 
  },
  topSection: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "var(--sp-xs)"
  },

  billingAmount: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    background: "#f5f5f5",
    padding: "calc(var(--sp-xxs)*2) calc(var(--sp-xxs)*3)",
    borderRadius: "var(--sp-sm)",
  },
  billingTitle: {
    fontSize: "var(--fs-md)",
    fontWeight: "600",
    color: "#616161",
  },
  annualAmount: {
    fontSize: "var(--fs-sm2)",
    fontWeight: "bold",
    color: "#1E88E5",
  },
  monthlyAmount: {
    fontSize: "var(--fs-sm2)",
    fontWeight: "bold",
    color: "#FFA726",
  },
  totalAmount: {
    fontSize: "var(--fs-md2)",
    fontWeight: "bold",
    color: "#D32F2F",
  },

  billingAmountsContainer: {
    display: "flex",
    padding: "calc(var(--sp-xxs)*2) calc(var(--sp-xxs)*3)",
    background: "#f5f5f5", 
    gap: "calc(var(--sp-xxs)*2)",
  },

  totalSection: {
    background: "#ffebee", 
  },

  mainPaperLoc:{
    width: "100%",
    display: "flex",
    marginTop:'calc(var(--sp-md2)*1.6981)',
    flexDirection: "column",
    gap:'calc(var(--sp-md2)*1.6981)'
  },

  containerTable:{
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
  },

  tableHeader: {
    fontSize: "calc(var(--fs-xs)*1.368421)",
    fontWeight: 500,
    color:'rgba(106, 106, 137, 1)'
  },
  tableBody: {
    fontSize: "calc(var(--fs-xs)*1.368421)",
    fontWeight: 400,
    color:'rgba(0, 0, 0, 1)',
    padding:'0 !important'
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "center",
    gap: "calc(var(--sp-md2)*1)",
  },
  actionButton: {
    backgroundColor: "white",
    border: "1px solid rgba(150, 150, 150, 0.3)",
    padding: "calc(var(--sp-xxs)*2) var(--fs-md2)",
    borderRadius: "calc(var(--sp-xs)*1)",
    cursor: "pointer",
    width: "calc(var(--fs-hero)*4.2453)",
    textAlign: "center",
    fontSize: "calc(var(--fs-xs)*1.3207)",
    fontWeight: "normal",
    "&:hover": {
      backgroundColor: "#F5F5F5", 
    },
  },
  actionTextActivate: {
    color: "#23a30e",
    fontWeight: "normal", 
  },
  actionTextCancel: {
    color: "#FF0000", 
    fontWeight: "normal",
  },
  actionTextResume: {
    color: "#ffa500",
    fontWeight: "normal",
  },
  deleteButton: {
    background: 'white',
    borderRadius: "calc(var(--sp-lg)*2.3584)",
    padding: 'calc(var(--sp-xs)*1)',
    fontSize: "calc(var(--fs-xs)*2.8301)",
    boxShadow: '-2px 6px 12px -7px #000',
    color: 'red'
  },
  manageButton: {
    background: "linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(248,250,252,1) 100%) !important",
    color: "rgba(69, 69, 86, 1)",
    border: "1px solid rgba(226, 232, 240, 1)",
    padding: "calc(var(--sp-xxs)*2) calc(var(--sp-md2)*1.6981)",
    borderRadius: "var(--sp-xxs)",
    cursor: "pointer",
    width: "calc(var(--fs-hero)*2.8301)",
    textAlign: "center",
    fontSize: "calc(var(--fs-xs)*1.368421)",
    fontWeight: 400,
  },
  tableCenteredHeader: {
    textAlign: "center",
    fontSize: "calc(var(--fs-xs)*1.368421)",
    fontWeight: "bold",
    width: "100%",
  },

});

export const getTabStyle = (isSelected) => ({
  borderBottom: `1px solid ${isSelected ? "#F8B218" : "#C8C8C8"}`,
  color: isSelected ? "#F8B218" : "#C8C8C8",
  fontSize: "calc(var(--fs-xs)*1.578947)",
  fontWeight: "500",
  lineHeight: "var(--sp-lg)",
  textTransform: "capitalize",
  maxWidth: "calc(var(--fs-hero) * 8.4905)",
  minWidth: 0,
  padding: "calc(var(--sp-md2) * 1.132075) calc(var(--sp-md2) * 1.50943)",
});